import Link from "next/link";
import Logo from "./logo";
import MenuToggle from "./menuToggle";

interface Props {
  isOpen: boolean;
  toggle: () => void;
}

export default function Header({ isOpen, toggle }: Props) {
  return (
    <header className="absolute inset-x-0 top-0 z-50 ease-in-out">
      <div className="bg-blue px-8 py-4 text-center">
        🚀 Ready to shape the future of technology and innovation? Join our
        community in Munich:
        <Link
          href="https://application.cdtm.com"
          className="link ml-2 mr-2 text-inherit"
          target="_blank"
        >
          Apply now
        </Link>
      </div>
      <div className="flex items-center justify-between px-6 py-5">
        <Link href="/" onClick={() => isOpen && toggle()}>
          <Logo className="h-11" />
        </Link>
        <MenuToggle toggle={toggle} />
      </div>
    </header>
  );
}
